import { ReportMetaData } from '@treasury/domain/reports/report-meta-data.entity';
import { format, subDays } from 'date-fns';

export class ReportMetaDataVm {
    constructor(private readonly reportMetaData: ReportMetaData) {}

    public get date() {
        if (this.dateType.toLowerCase().includes('current')) {
            return format(new Date(), 'P');
        } else if (this.dateType.toLowerCase().includes('prior')) {
            return format(subDays(new Date(), 1), 'P');
        } else {
            return ``;
        }
    }

    public get id() {
        return this.reportMetaData.id;
    }

    public get name() {
        return this.reportMetaData.name;
    }

    public set name(value: string) {
        this.reportMetaData.name = value;
    }

    public get detail() {
        if (this.dateType === 'Date Range') {
            return `${this.dateType}`;
        }
        return `${this.dateType}: ${this.specificDate} `;
    }

    public get reportType() {
        return this.reportMetaData.reportType;
    }

    public get isStandardReport() {
        return this.reportMetaData.isStandardReport;
    }

    public get dateType() {
        return this.reportMetaData.dateType;
    }

    public get fromDate() {
        if (!this.reportMetaData.fromDate) {
            return '';
        }
        return format(new Date(this.reportMetaData.fromDate || ''), 'P');
    }

    public get toDate() {
        if (!this.reportMetaData.toDate) {
            return '';
        }
        return format(new Date(this.reportMetaData.toDate || ''), 'P');
    }

    public get specificDate() {
        if (!this.reportMetaData.specificDate) {
            return '';
        }
        return format(new Date(this.reportMetaData.specificDate ?? ''), 'P');
    }

    public get accountTypes() {
        return this.reportMetaData.accountTypes;
    }

    public get accounts() {
        return this.reportMetaData.accounts;
    }

    public get type() {
        return this.reportMetaData.type;
    }

    public get metaData() {
        return this.reportMetaData.toDto();
    }

    public get report() {
        return this.reportMetaData;
    }
}
